const EmojiConvertor = require("emoji-js");

const emojiConverter = new EmojiConvertor();

// Always return native Unicode so the result remains safe to render with v-text.
emojiConverter.replace_mode = "unified";
emojiConverter.allow_native = true;
emojiConverter.avoid_ms_emoji = false;

function emojifyText(value) {
    if (value === null || value === undefined) return "";

    return emojiConverter.replace_colons(String(value));
}

function insertTextAtSelection(value, insertion, selectionStart, selectionEnd) {
    const text = String(value || "");
    const insertedText = String(insertion || "");
    const start = Math.max(
        0,
        Math.min(
            Number.isInteger(selectionStart) ? selectionStart : text.length,
            text.length
        )
    );
    const end = Math.max(
        start,
        Math.min(Number.isInteger(selectionEnd) ? selectionEnd : start, text.length)
    );

    return {
        text: text.slice(0, start) + insertedText + text.slice(end),
        cursor: start + insertedText.length,
    };
}

module.exports = {
    emojifyText,
    insertTextAtSelection,
};
